import { PRODUCT_DIGITAL_FILE_UUID, PRODUCT_DIGITAL_GROUP_FILE_UUID, PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID, } from "../Webshop/providers/PriceListProvider";
export function filterBuyablePictures(pictures, getProductByUuid) {
    const digitalMiniGroupProduct = getProductByUuid(PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID);
    const individualPictureProduct = getProductByUuid(PRODUCT_DIGITAL_FILE_UUID);
    const groupPictureProduct = getProductByUuid(PRODUCT_DIGITAL_GROUP_FILE_UUID);
    return pictures.filter((picture) => {
        if (picture.pictureType === "IP" && individualPictureProduct) {
            return true;
        }
        if (picture.pictureType === "MGP" && digitalMiniGroupProduct) {
            return true;
        }
        if (picture.pictureType === "GP" && groupPictureProduct) {
            return true;
        }
        return false;
    });
}
